import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import { MutationFetchFunction } from 'common/helpers/common';
import { ApiError, ApiResult } from 'common/repositories/common.model';

import {
  DocumentPurchaseVoidInput,
  DocumentPurchaseMutationInput,
  DocumentPurchaseUpdateInput,
  DocumentPurchaseModel,
} from './model';

export function useCreateTravelDocumentPurchase(
  options?: UseMutationOptions<
    ApiResult<DocumentPurchaseModel>,
    ApiError,
    DocumentPurchaseMutationInput
  >,
) {
  return useMutation<
    ApiResult<DocumentPurchaseModel>,
    ApiError,
    DocumentPurchaseMutationInput
  >(async (body) => {
    return await MutationFetchFunction({
      url: 'document-purchases',
      method: 'POST',
      body,
      classType: DocumentPurchaseModel,
    });
  }, options);
}

export function useUpdateTravelDocumentPurchase(
  options?: UseMutationOptions<
    ApiResult<DocumentPurchaseModel>,
    ApiError,
    DocumentPurchaseUpdateInput
  >,
) {
  return useMutation<
    ApiResult<DocumentPurchaseModel>,
    ApiError,
    DocumentPurchaseUpdateInput
  >(async (body) => {
    return await MutationFetchFunction({
      url: `document-purchases/${body.id}`,
      method: 'PUT',
      body: body.body,
      classType: DocumentPurchaseModel,
    });
  }, options);
}

export function useVoidTravelDocumentPurchase(
  options?: UseMutationOptions<
    ApiResult<any>,
    ApiError,
    DocumentPurchaseVoidInput
  >,
) {
  return useMutation<ApiResult<any>, ApiError, DocumentPurchaseVoidInput>(
    async (body) => {
      return await MutationFetchFunction({
        url: `document-purchases/${body.id}/void`,
        method: 'PATCH',
      });
    },
    options,
  );
}
